import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrashService {

  constructor(
    private _http: HttpClient
  ) { }

  getDeletedForms(organizationId, isHelpAdmin?) {
    let endpoint = ""
    if(isHelpAdmin) {
      endpoint = `${environment.url}/deletedForms/${organizationId}?isHelpAdmin=${isHelpAdmin}`
    } else {
      endpoint = `${environment.url}/deletedForms/${organizationId}`

    }
    return this._http.get(endpoint);
  }

  restoreDeletedForms(requestData) {
    return this._http.put(environment.url + "/forms/deleted/restore", requestData, { headers: { "hideLoader": "true" }});
  }
}
